import { useState } from "react";
import { api, apiError } from "../lib/api";

export default function FirstPassword({ user, onDone, onLogout }) {
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target));
    if (f.new_password !== f.confirm) return setError("New passwords do not match.");
    if (f.new_password.length < 8) return setError("New password must be at least 8 characters.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      onDone();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-panel">
        <div className="brand">Loan<span>Control</span></div>
        <div className="subtitle">Partner finance operations</div>
        <p className="login-note">PAN INDIA OPERATIONS · Fictional demonstration · No bank connections</p>
      </div>
      <div className="login-main">
        <form className="card login-card" noValidate onSubmit={submit} data-testid="first-password-form">
          <span className="pill warn">ACTION REQUIRED</span>
          <h1 style={{ marginTop: 14 }}>Choose your password</h1>
          <p className="muted">
            Signed in as {user.email}. You're using a temporary password from your administrator.
            Set your own password (at least 8 characters) to continue.
          </p>
          <label>Temporary password
            <input name="current_password" type="password" required autoComplete="current-password" data-testid="first-current-password-input" />
          </label>
          <label style={{ marginTop: 14 }}>New password
            <input name="new_password" type="password" required minLength={8} autoComplete="new-password" data-testid="first-new-password-input" />
          </label>
          <label style={{ marginTop: 14 }}>Confirm new password
            <input name="confirm" type="password" required minLength={8} autoComplete="new-password" data-testid="first-confirm-password-input" />
          </label>
          {error && <div className="notice warning space" role="alert" data-testid="first-password-error">{error}</div>}
          <button type="submit" className="primary login-btn" disabled={busy} data-testid="first-password-save-btn">
            {busy ? "Saving…" : "Save and continue"}
          </button>
          <button type="button" className="login-btn" onClick={onLogout} data-testid="first-password-logout-btn">Sign out</button>
        </form>
      </div>
    </div>
  );
}
